import { Icon } from "@iconify/react";
import { Form } from "antd";
import type { InputHTMLAttributes } from "react";
import { onRemove } from "../../helper/method";

export default function ImageCard({
  id,
  name,
  inputProps,
  setFile,
  file,
  multiple = false,
  pdf = false,
  mobile = false,
  required = true,
  title,
}: {
  id: string;
  name: string;
  setFile: React.Dispatch<
    React.SetStateAction<
      {
        file: File | undefined;
        fileUrl: string;
        id: string;
      }[]
    >
  >;
  file: {
    file: File | undefined;
    fileUrl: string;
    id: string;
  }[];
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  multiple?: boolean;
  pdf?: boolean;
  mobile?: boolean;
  required?: boolean;
  title?: string;
}) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files) return;

    const newFiles = Array.from(files).map((f) => ({
      file: f,
      id: `${f.name}-${Date.now()}`,
      fileUrl: URL.createObjectURL(f),
    }));

    if (!multiple) {
      setFile(newFiles);
      return;
    }
    setFile((prev) => [...prev, ...newFiles]);
  };

  return (
    <Form.Item
      name={name}
      rules={
        required
          ? [
              {
                validator: () =>
                  file.length
                    ? Promise.resolve()
                    : Promise.reject(new Error("عکس اجباری است")),
              },
            ]
          : []
      }
      className="mb-0!"
    >
      <label
        htmlFor={id}
        className="border flex-col items-center px-3 cursor-pointer gap-8 w-full! h-full! flex border-grayscale-200 py-12 rounded-2xl"
      >
        <div className="w-14 h-14 rounded-xl text-primary-500 flex-center bg-primary-100">
          <Icon icon={"solar:upload-linear"} className="text-3xl" />
        </div>
        <div className="flex flex-col gap-3 text-center">
          {title ? (
            <span className="text-18-bold">{title}</span>
          ) : (
            <span className="text-18-bold">
              {pdf
                ? "فایل خود را بارگذاری کنید"
                : mobile
                  ? "تصویر مربوط به موبایل را بارگذاری کنید."
                  : "تصویر مربوط به دسکتاپ خود را بارگذاری کنید."}
            </span>
          )}
          {pdf ? (
            <div className="text-16-semi-bold gap-4 flex flex-col items-center">
              {file.map((e, i) => (
                <div
                  key={i + "pre-view-file"}
                  className="items-center flex gap-3"
                >
                  {e.id}
                  <button
                    type="button"
                    onClick={() => {
                      onRemove(e.id, setFile);
                    }}
                    className="text-lg! text-error-600! cursor-pointer"
                  >
                    <Icon icon={"ic:baseline-cancel"} />
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <span className="text-16-semi-bold">
              فایل را به اینجا بکشید یا از دستگاه خود{" "}
              <strong className="text-info-500 underline-offset-4 underline">
                انتخاب
              </strong>{" "}
              کنید.
            </span>
          )}
          <span className="text-16-regular">JPG،PNGتا سقف ۲۰ مگابایت</span>
        </div>
      </label>
      <input
        onChange={handleChange}
        name={name}
        accept={`image/*,${pdf ? "application/pdf" : ""}`}
        id={id}
        type="file"
        className="hidden!"
        {...inputProps}
      />
    </Form.Item>
  );
}
